module.exports = __webpack_public_path__ + "static/media/ban-member.af363f27.svg";